module.exports = __webpack_public_path__ + "images/marketing/side_gradient.jpg";